import { AxiosResponse } from "axios";
import { Plan } from "./models/plan.model";
import talentApi from "./talent-api-config";
import { NextPlan } from "../../models/next-plan.model";

class PlanApi {
  async getPlan(): Promise<AxiosResponse<Plan>> {
    return await talentApi.get<Plan>("/talent/plan");
  }

  async getNextPlans(): Promise<AxiosResponse<NextPlan[]>> {
    return await talentApi.get<NextPlan[]>("/talent/plan/next");
  }
}

export const planApi = new PlanApi();
